import { useEffect, useState } from 'react'
import { getRegion } from './lib/checkout.js'

/// Returns { country, isPH, loading } for the current visitor based on
/// Vercel's edge geo header. Cached on the server side, so re-mounts cheap.
export function useRegion() {
  const [country, setCountry] = useState(null)
  const [isPH, setIsPH] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    getRegion().then(r => {
      if (cancelled) return
      setCountry(r.country)
      setIsPH(!!r.is_ph)
      setLoading(false)
    })
    return () => { cancelled = true }
  }, [])

  return { country, isPH, loading }
}
